export default class breadcrumb {

  constructor() {

      this.breadcrumb = document.querySelector('.cp-breadcrumb');
      if (!this.breadcrumb) return;
      if (this.breadcrumb.offsetHeight < 20) this.breadcrumb.classList.add('one-line');

      window.addEventListener("resize", () => {
        this.breadcrumb.offsetHeight < 20 ? this.breadcrumb.classList.add('one-line') : this.breadcrumb.classList.remove('one-line');
      });
  }
}
